import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios
      .post(`${API}/auth/session`, { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/playlists", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#080C14]" data-testid="auth-callback-loading">
      <div className="flex items-center gap-3 text-sm font-semibold text-cyan-300">
        <Loader2 size={22} className="animate-spin" />
        Connexion en cours…
      </div>
    </div>
  );
}
